<script setup lang="ts">
import { computed } from 'vue';
import { CheckCircle2, Clock3 } from 'lucide-vue-next';
import type { InstallationTestStatus } from '@/domain/installation-guide';

/** Shared "Fertig" step: one plain outcome, no internal setup states. */
const props = defineProps<{ status?: InstallationTestStatus; includeConsent?: boolean }>();
const passed = computed(() => props.status?.status === 'passed');
const consentConfirmed = computed(() => passed.value && props.includeConsent);
</script>

<template>
  <section class="setup-step done-step" aria-labelledby="done-step-title">
    <span class="done-step__icon" :class="{ 'is-pending': !passed }"><CheckCircle2 v-if="passed" :size="28" /><Clock3 v-else :size="28" /></span>
    <h3 id="done-step-title">{{ passed ? 'Website verbunden' : 'Einrichtung gespeichert' }}</h3>
    <p v-if="passed">Moonshot empfängt Daten von deiner Website. Erkannte Firmen erscheinen unter Besucher.</p>
    <p v-else>Sobald der Tag auf deiner veröffentlichten Website läuft, kommen die ersten Daten an. Den Status findest du jederzeit in den Einstellungen.</p>
    <p v-if="consentConfirmed" class="setup-step__muted">Dein Cookie-Banner ist verbunden. Besucher-Funktionen starten nach Zustimmung.</p>
    <p v-else class="setup-step__muted">Besucher-Funktionen wie Sitzungen, Video und Heatmap starten erst, wenn dein Cookie-Banner verbunden ist. Das kannst du jederzeit nachholen.</p>
  </section>
</template>
